import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Popover } from "antd";
// import { useRoutes, NavLink, redirect, useNavigate } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { getToken } from "../utils/auth";
// import LogoBoth from "../assets/images/logo1.svg";
import LogoBoth from "../assets/images/login/BL-Logo.png";
import NewFeatAnn from "../assets/images/homePage/new-feat.svg";
import "../assets/css/dropdown1.css";
import "../assets/css/line-awesome.css";
import "../assets/css/line-awesome.min.css";
import {
  topSearch,
  selectItem,
  topSearchClick,
} from "../actionCreator/headerActionCreater";
import { AuthContext } from "../context/AuthContext";
import NotificationDropdown from "./NotificationDropdown";
import { getUserInfo } from "../utils/utils";

const Header = (props) => {
  const topSearchValue = useSelector(
    (state) => state?.HeaderReducer?.topSearchValue
  );
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { role, permissions } = getUserInfo();
  const { logout } = useContext(AuthContext);
  const [showNav, setShowNav] = useState();
  const [dropDownToggle, setDropdownToggle] = useState(false);
  const [searchValue, setSearchValue] = useState(topSearchValue);
  const selectedItem = useSelector(
    (state) => state?.HeaderReducer?.selectedItem
  );
  const toggleNav = (ele) => {
    setShowNav(!showNav);
  };
  const toggleDropdown = () => {
    setDropdownToggle(!dropDownToggle);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location.pathname === "/search-executive") {
      dispatch(selectItem("Executive"));
    } else if (location.pathname === "/search-company") {
      dispatch(selectItem("Company"));
    } else {
      dispatch(selectItem("Company"));
      dispatch(topSearch(""));
      setSearchValue("");
    }
  }, [location.pathname]);

  const setValue = (val, btn = false) => {
    dispatch(selectItem(val));
    dispatch(topSearchClick(Math.random()));

    if (!btn) {
      setDropdownToggle(!dropDownToggle);
    }
    dispatch(topSearch(searchValue));

    if (val === "Company") {
      navigate("/search-company");
    } else {
      navigate("/search-executive");
    }
  };

  const showSetting = () => {
    navigate("/my-account");
  };

  const isWebToLeadView = permissions?.["Web To Leads"]?.find(
    (d) => d?.name === "View"
  );
  const isEmailSetupView = permissions?.["Email Setup"]?.find(
    (d) => d?.name === "View"
  );
  const isRMView = permissions?.["Reputation Manager"]?.find(
    (d) => d?.name === "View"
  );
  const isLeadView = permissions?.["Leads"]?.find((d) => d?.name === "View");
  const isExecutiveView = permissions?.["Executive"]?.find(
    (d) => d?.name === "View"
  );
  const isCompanyView = permissions?.["Company"]?.find(
    (d) => d?.name === "View"
  );

  const content = (
    <div className="fontf">
      <p className="fs-12" onClick={showSetting}>
        <UserOutlined
          className="text-center fs-16 pop-img"
          style={{ marginRight: 7 }}
        />
        My Account
      </p>

      {(isEmailSetupView || isWebToLeadView || role === "ADMIN") && (
        <p
          className="fs-12"
          onClick={() =>
            navigate(
              role === "ADMIN"
                ? "/settings/user-management"
                : isWebToLeadView
                  ? "/settings/web-to-lead"
                  : "/settings/email-setup"
            )
          }
        >
          <i
            className="text-center fs-16 pop-img las la-cog"
            style={{ marginRight: 7 }}
          ></i>
          Settings
        </p>
      )}

      <p className="fs-12" onClick={logout}>
        <i
          className="text-center fs-16 pop-img las la-sign-out-alt"
          style={{ marginRight: 7 }}
        ></i>
        Sign out
      </p>
    </div>
  );

  const handleSetValue = (event) => {
    setSearchValue(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setValue(selectedItem, true);
    }
  };

  return (
    <header id="site-header" className="fixed-top roboto-regular">
      <div className="container">
        <nav className="navbar navbar-expand-lg stroke px-0">
          <div className="brand">
            <h1>
              {!getToken() ? (
                <NavLink to={"/"} className="navbar-brand">
                  <img src={LogoBoth} alt="" />
                </NavLink>
              ) : (
                <NavLink to={"/dashboard-view"} className="navbar-brand">
                  <img src={LogoBoth} alt="" />
                </NavLink>
              )}
            </h1>
          </div>
          <button
            className={
              (showNav ? "navbar-toggler" : "navbar-toggler collapsed") +
              "  bg-gradient"
            }
            type="button"
            data-toggle="collapse"
            data-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded={showNav ? true : false}
            aria-label="Toggle navigation"
            onClick={toggleNav}
          >
            <span className="navbar-toggler-icon fa icon-expand fa-bars"></span>
            <span className="navbar-toggler-icon fa icon-close fa-times"></span>
          </button>
          <div
            className={(showNav ? "show" : "") + " collapse navbar-collapse"}
            id="navbarTogglerDemo02"
          >
            <div className="search-advance">
              <div className="search-main-wrapper">
                {/* Search Input */}
                <input
                  type="search"
                  placeholder="Search..."
                  value={searchValue}
                  onChange={handleSetValue}
                  onKeyPress={handleKeyPress}
                  className="searchInputClass"
                />

                {/* Dropdown Toggle */}
                <div onClick={toggleDropdown} className="dropdownToggleDiv">
                  <span style={{ marginRight: "4px", fontSize: "12px" }}>
                    {selectedItem}
                  </span>
                  <i
                    className="fa fa-chevron-down"
                    style={{ fontSize: "10px" }}
                  ></i>
                </div>

                {/* Search Button */}
                <button
                  type="button"
                  onClick={() => setValue(selectedItem, true)}
                  className="searchBtnHeader"
                >
                  <i className="fa fa-search" style={{ color: "black" }}></i>
                </button>

                {/* Dropdown List */}
                {dropDownToggle && (
                  <ul className="drpdown-toggle-list-ul">
                    <li
                      onClick={() => setValue("Company")}
                      className="drpdown-toggle-list-ul-li"
                    >
                      <i
                        className="la la-building"
                        style={{ marginRight: "6px" }}
                      ></i>
                      Company
                    </li>
                    <li
                      onClick={() => setValue("Executive")}
                      className="drpdown-toggle-list-ul-li"
                    >
                      <i
                        className="la la-user-tie"
                        style={{ marginRight: "6px" }}
                      ></i>
                      Executive
                    </li>
                  </ul>
                )}
              </div>
              {/* </div> */}
              {!getToken() ? (
                <>
                  <div className="">
                    <div className="dropdown-menu1">
                      <button
                        className="dropbtn"
                        style={{ fontSize: "14px", fontWeight: "bold" }}
                      >
                        Products
                        <i className="fa fa-caret-down ml-1"></i>
                      </button>
                      <div className="dropdown-menu-content header-more-menu">
                        <div className="grid-auto-fit">
                          <div className="more-sub-menu">
                            <h2 className="sub-menu-heading heading18px mb20">
                              Hospitality - Focused Solutions
                            </h2>

                            <div className="mb30">
                              <div className="more-sub-menu-img">
                                <i className="las la-hotel"></i>
                              </div>
                              <div className="more-sub-menu-right-text">
                                <NavLink to={"/hospitality"}>
                                  <h3 className="heading16px">
                                    {" "}
                                    <strong> Hotel Lead Engine </strong>
                                  </h3>
                                  <p className="sub-text heading12px">
                                    Maximize guest acquisition
                                  </p>
                                </NavLink>
                              </div>
                            </div>
                            <div>
                              <div className="more-sub-menu-img">
                                <i className="la la-star-half-alt"></i>
                              </div>
                              <div className="more-sub-menu-right-text">
                                <NavLink to={"/review-management"}>
                                  <h3 className="heading16px">
                                    {" "}
                                    <strong>
                                      {" "}
                                      Reputation & Review Management{" "}
                                    </strong>
                                  </h3>
                                  <p className="sub-text heading12px">
                                    Automate guest feedback
                                  </p>
                                </NavLink>
                              </div>
                            </div>
                          </div>

                          <div className="more-sub-menu">
                            <h2 className="sub-menu-heading heading18px mb20">
                              Key Functions
                            </h2>

                            <div className="mb30">
                              <div className="more-sub-menu-img">
                                <i className="la la-handshake"></i>
                              </div>
                              <div className="more-sub-menu-right-text">
                                <NavLink to={"/sales"}>
                                  <h3 className="heading16px">
                                    {" "}
                                    <strong> Sales Pipeline Growth </strong>
                                  </h3>
                                  <p className="sub-text heading12px">
                                    Discover and book guests
                                  </p>
                                </NavLink>
                              </div>
                            </div>

                            <div className="mb30">
                              <div className="more-sub-menu-img">
                                <i className="la la-briefcase"></i>
                              </div>
                              <div className="more-sub-menu-right-text">
                                <NavLink to={"/marketing"}>
                                  <h3 className="heading16px">
                                    {" "}
                                    <strong>
                                      {" "}
                                      Targeted Marketing Automation{" "}
                                    </strong>
                                  </h3>
                                  <p className="sub-text heading12px">
                                    Personalized audience campaigns
                                  </p>
                                </NavLink>
                              </div>
                            </div>
                          </div>

                          <div className="more-sub-menu">
                            <h2 className="sub-menu-heading heading18px mb20">
                              Core Capabilities
                            </h2>

                            <div className="mb30">
                              <div className="more-sub-menu-img">
                                <i className="text-success la la-user-plus"></i>
                              </div>
                              <div className="more-sub-menu-right-text">
                                <NavLink to={"/data-to-lead"}>
                                  <h3 className="heading16px">
                                    {" "}
                                    <strong>Data-to-Lead</strong>
                                  </h3>
                                  <p className="sub-text heading12px">
                                    Turn data into direct leads
                                  </p>
                                </NavLink>
                              </div>
                            </div>

                            <div>
                              <div className="more-sub-menu-img">
                                <i className="la la-cloud-upload-alt"></i>
                              </div>
                              <div className="more-sub-menu-right-text">
                                <NavLink to={"/lead-enrichment"}>
                                  <h3 className="heading16px">
                                    {" "}
                                    <strong>AI-Lead Enrichment</strong>
                                  </h3>
                                  <p className="sub-text heading12px">
                                    Enhance and validate data
                                  </p>
                                </NavLink>
                              </div>
                            </div>

                            <NavLink
                              to="/what-we-offer"
                              style={{
                                position: "absolute",
                                right: 0,
                                bottom: -20,
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#1d1e1f",
                                textDecoration: "none",
                                display: "inline-block",
                              }}
                            >
                              <img
                                src={NewFeatAnn}
                                alt="AI-Powered Features Built for Hospitality Workflows"
                                style={{
                                  width: 30,
                                  height: 30,
                                  background: "#f5f9fc",
                                  borderRadius: "50%",
                                  padding: "2px",
                                  lineHeight: "30px",
                                }}
                                title="Discover the Latest & Trending Features"
                              />
                              &nbsp; AI-Powered Features Built for Hospitality
                              Workflows
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
            <ul className="navbar-nav ml-lg-auto">
              {((isCompanyView && getToken()) || !getToken()) && (
                <li className="nav-item ">
                  <NavLink
                    to="/search-company"
                    className="hvr-underline-from-center"
                  >
                    Company Search
                  </NavLink>
                </li>
              )}
              {((isExecutiveView && getToken()) || !getToken()) && (
                <li className="nav-item">
                  <NavLink
                    to="/search-executive"
                    className="hvr-underline-from-center"
                  >
                    Executive Search
                  </NavLink>
                </li>
              )}

              {getToken() ? (
                <>
                  {isLeadView && (
                    <li className="nav-item">
                      <NavLink
                        to="/search-lead"
                        className="hvr-underline-from-center"
                      >
                        Leads
                      </NavLink>
                    </li>
                  )}

                  <li className="nav-item">
                    <NavLink
                      to="/dashboard-view"
                      className="hvr-underline-from-center"
                    >
                      Dashboard
                    </NavLink>
                  </li>
                  {isRMView && (
                    <li className="nav-item">
                      <NavLink
                        to="/reputation-manager/settings"
                        className="hvr-underline-from-center"
                      >
                        Reputation Manager
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item d-flex align-items-center cursor-pointer">
                    <NotificationDropdown />
                  </li>

                  <li className="nav-item mt-2 account">
                    {" "}
                    <Popover content={content} trigger="hover">
                      <div></div>
                    </Popover>
                  </li>

                  <li
                    className="nav-item mt-2"
                    style={{ marginTop: "6px", padding: "5px" }}
                  >
                    <NavLink to="/what-we-offer" target="_blank">
                      <img
                        src={NewFeatAnn}
                        alt="AI-Powered Features Built for Hospitality Workflows"
                        title="AI-Powered Features Built for Hospitality Workflows"
                      />
                    </NavLink>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <NavLink
                      to="/lead-management"
                      className="hvr-underline-from-center"
                    >
                      Leads
                    </NavLink>
                  </li>

                  <li className="nav-item">
                    <NavLink
                      to="/pricing"
                      className="hvr-underline-from-center"
                    >
                      Pricing
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <div className="nav-item btn btn-login d-flex align-items-center">
                      <NavLink to={"/signin"}>
                        <i className="fas fa-desktop orng-clr-bg ml-1"></i>Login
                      </NavLink>
                    </div>
                  </li>
                  <li className="nav-item">
                    <div className="nav-item btn btn-login d-flex align-items-center">
                      <NavLink to={"/signup"}>
                        <i className="fas fa-bolt orng-clr-bg ml-1"></i>start
                        free trial
                      </NavLink>
                    </div>
                  </li>
                </>
              )}
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
